import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Emily Thompson',
  text: "The most relaxing experience I've ever had. The hot stone massage completely melted away months of stress. The atmosphere is incredibly serene.",
  rating: 5
}, {
  name: 'Michael Rodriguez',
  text: 'As an athlete, I need serious deep tissue work. David knew exactly how to target my problem areas without it being painful. Highly recommend.',
  rating: 5
}, {
  name: 'Sarah Chen',
  text: 'I booked a prenatal massage here and it was heavenly. The therapist was so attentive and made sure I was comfortable the entire time.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-24 bg-[#0A0A0A] text-[#F5F0EB]" data-id="element-222">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
        <div className="text-center mb-16" data-id="element-224">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl mb-4 text-[#F5F0EB]" data-id="element-225">
            Client Stories
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '80px'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="h-1 bg-[#D4AF37] mx-auto mb-6" data-id="element-226" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-227">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-[#1A1A1A]/50 p-8 rounded-sm relative border border-[#2A2A2A]" data-id="element-228">
              <Quote className="absolute top-6 right-6 text-[#D4AF37]/30 w-12 h-12" data-id="element-229" />
              <div className="flex mb-6" data-id="element-230">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 text-[#D4AF37] fill-current" data-id="element-231" />)}
              </div>
              <p className="text-lg italic mb-6 leading-relaxed relative z-10 text-[#F5F0EB]" data-id="element-232">
                "{testimonial.text}"
              </p>
              <p className="font-semibold uppercase tracking-wider text-sm text-[#D4AF37]" data-id="element-233">
                — {testimonial.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}